<div class="absolute" style="top: -30px">
  <app-notification></app-notification>
</div>
<div class="inline-flex align-items-center gap-2 mb-5">
  <img
    src="https://ui-avatars.com/api/?name={{ user.firstname + '+' + user.lastname }}"
    width="30"
    height="30"
    style="border-radius: 50%"
    alt="" />
  <span class="font-bold text-lg white-space-nowrap">{{ "Bienvenue " + user.firstname }}</span>
</div>
<div class="grid">
 <!--  <div class="col-12 grid nested-grid">
    <div class="col-8">
      <div class="grid">
        <div class="col-12 grid pr-0">
          <div class="col-4">
            <p-card class="shadow-1 kpi-card w-full">
              <i class="pi pi-file-check text-2xl mb-2"></i>
              <p class="m-0">Volume total de fiches</p>
              <p class="text-3xl font-bold">19 322</p>
            </p-card>
          </div>
          <div class="col-4">
            <p-card class="shadow-1 kpi-card w-full">
              <i class="pi pi-file-check text-2xl mb-2"></i>
              <p class="m-0">Volume total de fiches</p>
              <p class="text-3xl font-bold">19 322</p>
            </p-card>
          </div>
          <div class="col-4 pr-0">
            <p-card class="shadow-1 kpi-card w-full">
              <i class="pi pi-file-check text-2xl mb-2"></i>
              <p class="m-0">Volume total de fiches</p>
              <p class="text-3xl font-bold">19 322</p>
            </p-card>
          </div>
        </div>
        <div class="col-12">
          <p-card class="shadow-1 kpi-card w-full">
            <div>
              <span class="font-bold text-lg">Suivi import catalogue</span>
            </div>
            <div echarts [options]="barChartOption" class="demo-chart"></div>
          </p-card>
        </div>
      </div>
    </div>
    <div class="col-4 pb-0">
      <div class="grid h-full">
        <div class="col-12 h-full">
          <p-card class="shadow-1 kpi-card w-full" styleClass="h-full">
            <div>
              <span class="font-bold text-lg">Répartition catalogue</span>
            </div>
            <div>
              <div echarts [options]="typologyOption" class="chart-container"></div>

              <div id="custom-legend">
                @for (legend of legendData; track $index) {
                  <div class="legend-item">
                    <span class="legend-color" [style.background-color]="legend.color"></span> {{ legend.name }}
                  </div>
                }
              </div>
            </div>
          </p-card>
        </div>
      </div>
    </div>
  </div> -->
  <div class="col-12 grid">
   <!--  <div class="col-12">
      <p-card class="shadow-1 kpi-card w-full" styleClass="h-full">
          <div>
            <span class="font-bold text-lg">Derniers imports</span>
          </div>
        <app-import-history [status]="[]" [max]="3" #importHistoryComponent [hideFilters]="true" [hideSearch]="true"></app-import-history>
      </p-card>
    </div> -->
    <!-- <div class="col-4">
      <p-card class="shadow-1 kpi-card w-full" styleClass="h-full">
        <div>
          <span class="font-bold text-lg">Attributs</span>
        </div>
        <app-dashboard-attribute></app-dashboard-attribute>
      </p-card>
    </div> -->
  </div>
</div>
